// The cluster debug-mode channel (#260 part B, Luca's dictation 2026-08-09).
//
// One CLUSTER-wide boolean (Cluster.debugMode, edited in Sistema >
// Impostazioni globali) decides whether the generic error alerts append the
// underlying cause. The value is needed synchronously inside every catch, so
// it lives here as a module-wide flag on the usePermissions model: ONE lazy
// GET /cluster primes it (never a fetch per toast), the Impostazioni globali
// view republishes on its own poll/save, and ignorance reads as OFF — the
// reduced face of GET /cluster (no cluster-root authority) simply never
// carries the field, so a scoped operator keeps today's generic messages.

import { apiClient } from '@/libs/api'
import { getSession } from '@/utils/session'


let debugMode = false
let settled = false
let inflight = false
let lastAttemptAt = 0

// A failed courtesy fetch must not stick OFF forever nor hammer the API: one
// retry window per minute, next consumer triggers it.
const RETRY_MS = 60000


function ensureFetched(): void {
  if (settled || inflight || typeof window === 'undefined' || getSession() === null) {
    return
  }

  if (Date.now() - lastAttemptAt < RETRY_MS) {
    return
  }

  lastAttemptAt = Date.now()
  inflight = true

  apiClient()
    .cluster.get()
    .then(cluster => {
      debugMode = cluster.debugMode === true
      settled = true
    })

    // Errors answer OFF and leave `settled` false: a later consumer retries
    // after the window — the flag is a courtesy, never worth an error of its own.
    .catch(() => {})
    .finally(() => {
      inflight = false
    })
}


// Synchronous read for the error helpers: current knowledge, priming the
// channel on first use.
export const clusterDebugMode = (): boolean => {
  ensureFetched()

  return debugMode
}


// The push half: any view that already holds a fresh full Cluster (the
// Impostazioni globali poll, its save handler) publishes here so a toggle is
// live without waiting for a reload.
export const publishClusterDebugMode = (value: boolean): void => {
  debugMode = value
  settled = true
}
